// removed by extract-text-webpack-plugin
module.exports = {"Content":"_2cvxVRZjeUBHIUOdqNTLgQ","Column":"_1AmvGpUxLt98Ux7yJq2Tmj","Title":"_2K2I11HzV-Qb2r4xfgWSqk","Text":"_2FrNvyJkp9tfUcTQdo1T2Y","InputWrap":"fV5e2mGKNxkKzNBXmG3HE","DoubleCell":"_2EWzayKFd2F7vcnSY-_WKD","Input":"_14sVmQlFORIUYCv2mmXkQq","Calendar":"XhVGN9iCd-gHKXyyxsqOj","Label":"_2QuIVjtqo83raidFpCb543","container-fluid":"_2_wpsQrT8EIeJnv7fnIclM"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/PrepaidActivate/styles.module.css
// module id = 640
// module chunks = 0